import React from 'react';
import {Menu, Dropdown} from 'semantic-ui-react';
import {Component, Fragment, indicators, demographics, captions, jQuery} from './Helpers';
import {CSSTransitionGroup} from 'react-transition-group';
import Context from './Context';
import * as d3 from 'd3';
import {default as UUID} from "node-uuid";

class BaseChart extends Component {
  constructor(props){
    super(props);
    this.state =  {
      drawn: false
    }

    this.debug = false;
    this.svg = null;
    this.bisector = d3.bisector(d => d.year ).right;
    this.x = d3.scaleLinear();
    this.y = d3.scaleLinear();;

    this.xAxis = d3.axisBottom().scale(this.x).ticks(13).tickFormat((d,i,j) =>
      `${i % 2 != 0 && i != j.length - 1 && (this.props.step < 3 || typeof this.props.lockStep !== 'undefined') ? `` :
        this.props.step  == 1 || this.props.lockStep == 1 ? 2007 + i :
        this.props.step == 2 || this.props.lockStep == 2 ?  1989 + i :
        i - 2 }`);

    this.yAxis = d3.axisLeft().scale(this.y).ticks(10).tickFormat((d,i,j) => i % 2 != 0 && i != j.length - 1 ? `` : this.props.indicator == 'labor-force-earnings' ?
      i == j.length - 1 ? d3.format('$.2s')(d) : d3.format('.2s')(d).split('k')[0] :
      i == j.length - 1 ? `${d}%` : `${d}`);

    this.bars = [ -1.5, -.75];
    this.valueline = d3.line()
        .x( (d,i)  =>  this.x(i))
        .y( (d,i)  => this.y(d));
  }

  mouseout = () => {
    d3.selectAll('.dot')
      .transition(d3.easeCircle)
      .duration(50)
      .attr('r', 3);

      for (let item of document.querySelectorAll(`#${this.state.id} .tooltip`)) {
        item.classList.remove('visible');
      }

      for (let item of document.querySelectorAll(`#${this.state.id} .recession`)) {
        item.classList.remove('dim');
      }

    document.querySelector(`#${this.state.id} .year`).classList.remove('visible');
  }

  mousemove = () => {
    let x0 = window.navigator.userAgent.indexOf('Firefox') > -1 && this.props.width >= 720 ? this.x.invert(d3.event.offsetX) : this.x.invert(d3.mouse(d3.select(`#${this.state.id} .overlay`).node())[0]),
          i = this.bisector(this.props.data[this.props.indicator][this.props.demographic][0].map( (d,i) => { return {value: d, year: i};}), x0 - .3, 0, 12),
          first = this.props.data[this.props.indicator][this.props.demographic][0][i],
          second = this.props.data[this.props.indicator][this.props.demographic][1][i],
          t1 = document.querySelectorAll(`#${this.state.id} .tooltip`)[0],
          t2 = document.querySelectorAll(`#${this.state.id} .tooltip`)[1],
          y = document.querySelector(`#${this.state.id} .year`),
          r1 = document.querySelector(`#${this.state.id} .recession.first`),
          r2 = document.querySelector(`#${this.state.id} .recession.second`),
          x = this.x(i);


    d3.selectAll(`#${this.state.id} .dot.first`)
      .transition(d3.easeCircle)
      .duration(70)
      .attr('r', (d,e) => e == i ? 6 : 3);

    d3.selectAll(`#${this.state.id} .dot.second`)
      .transition(d3.easeCircle)
      .duration(70)
      .attr('r', (d,e) => e == i ? 6 : 3);

    d3.select(`#${this.state.id} .year`)
    .transition(d3.easeCircle)
    .duration(50)
    .attr('x', x);

    y.classList.add('visible');
    t1.classList.add('visible');
    t2.classList.add('visible');

    r1.classList.add('dim');
    r2.classList.add('dim');

    t1.style.top = `calc(${this.y(first) - (second >= first ? -30 : 40)}px + ${this.props.width < 720 ? 30 : 0}px)`;
    t1.style.left = `calc(${ x + 20 }px)`;
    t1.innerHTML = `<span class="first">${1989 + i}</span><br/>${this.props.indicator == 'labor-force-earnings' ? first >= 100000 ? d3.format('$.4s')(first) : d3.format('$.3s')(first) : `${d3.format(`${first >=10 ? '.3s' : '.2s'}`)(first)}%`}`;

    t2.style.top = `calc(${this.y(second) - (first > second ? -30 : 40)}px + ${this.props.width < 720 ? 30 : 0}px)`;
    t2.style.left = `calc(${ x + 20}px)`;
    t2.innerHTML = `<span class="second">${2007 + i}<br/></span>${this.props.indicator == 'labor-force-earnings' ?  second >= 100000 ? d3.format('$.4s')(second) : d3.format('$.3s')(second)  : `${d3.format(`${second >=10 ? '.3s' : '.2s'}`)(second)}%`}`;
  }

  recessionTooltips = () => {
    const r1 = document.querySelector(`#${this.state.id} .recession.first`),
          r2 = document.querySelector(`#${this.state.id} .recession.second`),
          offset = this.props.ui && this.props.width < 720 ? 38 : this.props.ui ? 75 : 35;
    r1.style.top = `${(this.props.width < 720 ? 25 : 0)}px`;
    r1.style.left = `calc(${ this.x(1.65) + offset}px)`;
    r2.style.top = `${(this.props.width < 720 ? 5 : -20)}px`;
    r2.style.left = `calc(${ this.x(1.25) + offset}px)`;
  }


    draw = ( step, indicator, demographic) => {
          document.querySelector(`#${this.state.id} .chart`).innerHTML = ``;
          const d = this.props.data;
          const data = d[indicator][demographic][1];

          const margin = {top: 20, right: 14, bottom: 44, left: 42},
            width = document.querySelector(`#${this.state.id} .chart`).clientWidth - margin.left - margin.right,
            height = document.querySelector(`#${this.state.id} .chart`).clientHeight - margin.top - margin.bottom;


          this.x.range([0, width]).interpolate(d3.interpolateRound);
          this.y.range([height, 0]).interpolate(d3.interpolateRound);

          this.svg = d3.select(`#${this.state.id} .chart`)
              .append("svg")
                  .attr("width", width + margin.left + margin.right)
                  .attr("height", height + margin.top + margin.bottom)
              .append("g")
                  .attr("transform",
                        "translate(" + margin.left + "," + margin.top + ")");


            this.x.domain(d3.extent(data, function(d, i) { return i; }));
            if (indicator == 'unemployment-rate') {
              this.y.domain([0,20]);
            } else {
              this.y.domain(d3.extent([].concat(...Object.entries(d[indicator]).map( e=> e[1][0].concat(e[1][1]))))).interpolate(d3.interpolateRound);
            }


            this.svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(this.xAxis.tickSize(-height));


            this.svg.append("g")
                .attr("class", "y axis")
                .call(this.yAxis.tickSize(-width));


            this.svg.selectAll('rect')
              .data(this.bars)
              .enter()
              .append('rect')
              .attr('x', (d, i) => this.x(d + 2))
              .attr('width', (d) => this.x(Math.abs(d)))
              .attr('y',(d, i) => i == 1 ? height - height * .95 : 0)
              .attr('height', (d, i) => i == 1 ? height * .95 : height)
              .attr('class', (d,i) => `bar ${i == 1 ? 'first' : 'second'}`);


           this.svg.append('rect')
              .attr('class', 'year')
              .attr('x', 0)
              .attr('width', 2)
              .attr('y', 0)
              .attr('height', height);


            this.svg.append('text')
              .attr('class', 'x title')
              .attr('x', () => this.x(2))
              .attr('y', height + 40)
              .html('Years from the beginning of recovery &nbsp;&nbsp; &#x25ba;');


            // Add the valueline path.
            this.svg.append("path")
                .datum(d[indicator][demographic][1])
                .attr("class", "line second")
                .attr("d", this.valueline(d[indicator][demographic][1]));

            this.svg.append("path")
                .datum(d[indicator][demographic][0])
                .attr("class", "line first")
                .attr("d", this.valueline(d[indicator][demographic][0]));

            this.svg.selectAll(".dot.second")
                .data(d[indicator][demographic][1])
                .enter()
                .append("circle")
                .attr("class", "dot second")
                .attr("cx", (d,i) => this.x(i))
                .attr("cy", d => this.y(d))
                .attr("r", 3);


            this.svg.selectAll(".dot.first")
                    .data(d[indicator][demographic][0])
                    .enter()
                    .append("circle")
                    .attr("class", "dot first")
                    .attr("cx", (d,i) => this.x(i))
                    .attr("cy", d => this.y(d))
                    .attr("r", 3);

            this.svg.append('rect')
              .attr('class', 'overlay')
              .attr('width', width)
              .attr('height', height)
              .on('mouseout', () =>  this.mouseout())
              .on('mousemove', () =>  this.mousemove());

            this.recessionTooltips();
            this.setState({drawn: true});
    }

  redraw = (step, indicator, demographic, prevProps) => {
      const d = this.props.data;
      const data = d[indicator][demographic][1];
      this.x.domain(d3.extent(data, function(d, i) { return i; }));
      if (indicator == 'unemployment-rate') {
        this.y.domain([0,20]);
      } else {
        this.y.domain(d3.extent([].concat(...Object.entries(d[indicator]).map( e=> e[1][0].concat(e[1][1]))))).interpolate(d3.interpolateRound);
      }


       const transition = d3.select(`#${this.state.id} .chart`).transition();


        transition.select(".x.axis")
            .duration(750)
            .call(this.xAxis);
        transition.select(".y.axis")
            .duration(750)
            .call(this.yAxis);

       transition.select(".line.second")
           .duration(750)
           .attr("d", this.valueline(d[indicator][demographic][1]));
       transition.select(".line.first")
           .duration(750)
           .attr("d", this.valueline(d[indicator][demographic][0]));

      transition.selectAll('.bar')
         .duration(750)
         .attr('x', (d, i) => this.x(d + 2))
         .attr('width', (d) => this.x(Math.abs(d)))
         .attr('class', (d,i) => `bar ${i == 1 ? 'first' : 'second'}`);

      transition.select('.x.title')
        .duration(750)
        .attr('x', () => this.x(2));


        if (prevProps.indicator != indicator || ( prevProps.step != step && !this.props.ui && step > 0)) {
          d3.selectAll(`#${this.state.id} .dot`).remove();
          this.svg.selectAll(".dot.second")
              .data(d[indicator][demographic][1])
              .enter()
              .append("circle")
              .attr("class", "dot second")
              .attr("cx", (d,i) => this.x(i))
              .attr("cy", d => this.y(d))
              .attr("r", 0);


          this.svg.selectAll(".dot.first")
                  .data(d[indicator][demographic][0])
                  .enter()
                  .append("circle")
                  .attr("class", "dot first")
                  .attr("cx", (d,i) => this.x(i))
                  .attr("cy", d => this.y(d))
                  .attr("r", 0)


         this.svg.selectAll('.dot.second')
                  .transition(d3.easeBackOut)
                  .delay((d,i) => (this.props.ui ? 650 : 150) + i * 25)
                  .duration(625)
                  .attr('r', 3);

        this.svg.selectAll('.dot.first')
                 .transition(d3.easeBackOut)
                 .delay((d,i) => (this.props.ui ? 650 : 150) + i * 25)
                 .duration(625)
                 .attr('r', 3);
        } else {
          this.svg.selectAll(".dot.second")
              .data(d[indicator][demographic][1])
              .transition()
              .duration(750)
              .attr("cx", (d,i) => this.x(i))
              .attr("cy", d => this.y(d));


          this.svg.selectAll(".dot.first")
              .data(d[indicator][demographic][0])
              .transition()
              .duration(750)
              .attr("cx", (d,i) => this.x(i))
              .attr("cy", d => this.y(d));
        }
        this.recessionTooltips();
   }


  componentWillMount(){
    this.setState({id: `chart-${UUID.v4()}`});

  }

  componentDidMount() {
    if(typeof this.props.data == 'undefined' ) return;
    this.draw(this.props.step, this.props.indicator, this.props.demographic);
  }


  componentDidUpdate(prevProps) {
    if(typeof this.props.data == 'undefined' ) return;
    this.props.step = typeof this.props.lockStep !== 'undefined' ? this.props.lockStep : this.props.step;
    this.props.indicator = typeof this.props.lockIndicator !== 'undefined' ? this.props.lockIndicator : this.props.indicator;
    this.props.demographic = typeof this.props.lockDemographic !== 'undefined' ? this.props.lockDemographic : this.props.demographic;
    if (this.state.drawn === true && prevProps.width === this.props.width) {
      this.redraw(this.props.step, this.props.indicator, this.props.demographic, prevProps);
    } else {
      this.draw(this.props.step, this.props.indicator, this.props.demographic);
    }
    if (this.props.ui && (prevProps.indicator !== this.props.indicator || prevProps.demographic !== this.props.demographic)) {
      jQuery(`#${this.state.id} .caption`).transition('stop all');
      document.querySelector(`#${this.state.id} .caption`).style.opacity = 0;
      window.setTimeout(()=>  {
        jQuery(`#${this.state.id} .caption`).transition('slide in', '500ms');
        document.querySelector(`#${this.state.id} .caption`).style.opacity = 1;
      }, 120);
    }
  }

  render() {
    const step = this.props.lockStep || this.props.step;
    return (
      <div id={this.state.id} className="chartContainer" data-step={step} style={{width: this.props.ui && this.props.width > 720 ? '80%' : '100%', marginLeft:  0}}>
      {this.props.lockIndicator == 'unemployment-rate' ? <span class="title">Unemployment rate {step == 1 ? `during the Great Recession and recovery` :
        step == 2 ? `during the 1990-1991 recession and recovery` : `in the two recessions and recoveries`}</span> : null }
        <div className={`chart ${this.props.ui ? `last` : ``}`} data-step={step} style={{width: '100%', marginLeft: 0}}></div>
        <div className="tooltip first" data-step={step}></div>
        <div className="tooltip second" data-step={step}></div>
        <span className="recession first" data-step={step}><strong>1990-1991 recession</strong><br/><span>&#x25bc;</span></span>
        <span className="recession second" data-step={step}><strong>Great Recession, 2007-2009</strong><br/><span>&#x25bc;</span></span>
        <div className="caption" dangerouslySetInnerHTML={{ __html: this.props.ui ? captions[this.props.indicator][this.props.demographic] : null }} ></div>
      </div>
    );
  }
}


class Chart extends Component {

  render() {
      const options = [].concat(...demographics).map(d=> {return {key: d.key, text: d.name, value: d.key};});
      return (
        <Context.Consumer>
         {({step, indicator, width, data, demographic, set_indicator, set_demographic}) => (
          <div className="chart-ui" data-step={step}>

          { this.props.ui ?
             <Menu fluid widths={4} id='top-menu' >
             {
               indicators.map( d => <Menu.Item as="a" name={d.key} content={d.name} active={indicator === d.key} onClick={ (e,d) => set_indicator(e,d)} /> )
             }
             </Menu> : null }
           { this.props.ui ? width < 720 ?
            <Dropdown fluid selection options={options}  value={demographic} onChange={ (f,d) => { setTimeout(()=>set_demographic(f,{name:d.value, key:d.value}), 50);}}/> :
             <Menu secondary vertical id='left-menu' size='tiny'>
             {
                 demographics.map( e =>
                     <Menu.Item> {e.map( d =>
                       <Menu.Item as="a" name={d.key} content={d.name} active={demographic === d.key} onClick={ (f,d) => set_demographic(e,d)} />
                     )}
                     </Menu.Item>
                   )
             }
             </Menu>
           : null }

            <BaseChart data={data} width={width} step={step} indicator={indicator} demographic={demographic} {...this.props} />

          </div>
        )}
         </Context.Consumer>
      );
  }
}

export default Chart;
